import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["trigger", "submit"];

  constructor(...args) {
    super(...args);
    this.triggerChanged = this.triggerChanged.bind(this);
  }

  connect() {
    this.triggerChanged();

    this.triggerTargets.forEach((target) => {
      target.addEventListener("input", this.triggerChanged);
    });
  }

  disconnect() {
    this.triggerTargets.forEach((target) => {
      target.removeEventListener("input", this.triggerChanged);
    });
  }

  triggerChanged() {
    if (this.hasSubmitTarget) {
      const anyInputIsEmpty = this.triggerTargets.some((target) => !this.getInputValue(target));
      this.submitTarget.disabled = anyInputIsEmpty;
    }
  }

  getInputValue(input) {
    switch (input.type) {
      case "checkbox":
        return input.checked;
      case "radio":
        return input.checked ? input.value : null;
      default:
        return input.value.trim();
    }
  }
}
